export default class PositionData {
    constructor(
        positionId,
        latitude,
        longitude,
        speed,
        direction,
        geometry,
        etd,
        timestamp,
        operational,

    ) {
        this.positionId = positionId,
            this.latitude = latitude,
            this.longitude = longitude,
            this.speed = speed,
            this.direction = direction,
            this.geometry = geometry,
            this.etd = etd,
            this.timestamp = timestamp,
            this.operational = operational
    }

    get date() {
        return this.timestamp.split('T')[0]
    }

    get time() {
        return this.timestamp.split('T')[1]
    }
}